import React from "react";
import icon1 from "../../icons/icon-coin.svg";

const featuresData = [
  {
    icon: icon1,
    title: "Your Bonus Points Start Here",
    description: "Customers who reach 20,000 TopCoin become eligible to receive 10,000 bonus TopCoin when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (1)",
    description:
      "The first 500,000 customers to reach 200,000 TopCoin will receive an extra 25,000 free TopCoin when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (2)",
    description:
      "The first 100,000 customers to reach 2,000,000 TopCoin will receive 35,000 free TopCoin when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (3)",
    description:
      " The first 10,000 customers to reach 4,000,000 TopCoin will receive 50,000 free TopCoin when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (4)",
    description:
      "The first 1,000 customers to reach 8,000,000 TopCoin will receive 100,000 free TopCoin when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (5)",
    description:
      "The first 100 customers to reach 12,000,000 TopCoin will receive An additional 250,000 bonus TopCoin when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (6)",
    description:
      "The first 10 customers to reach 16,000,000 TopCoin will receive An additional 500,000 bonus TopCoin  when this wallet unlocks.",
  },
  {
    icon: icon1,
    title: "Bonus Points (7)",
    description:
      "The first customer to reach 20,000,000 TopCoin will receive An additional 1,000,000 bonus TopCoin  when this wallet unlocks.",
  },
];

const TokenomicsSection = () => {
  return (
    <section
      id="id_ico_tokenomics_section"
      className="ico_tokenomics_section section_space pb-5"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div
            className="ico_heading_block text-center col-lg-8"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <h5 className="text-uppercase fw-normal">
              Start Your Journey with TopCoin UK{" "}
            </h5>
            <h2 className="heading_text mb-0">
              {" "}
              Where Loyalty Becomes a Lifestyle
            </h2>
          </div>
        </div>

        <div className="row align-items-center">
          {featuresData.map((feature, index) => (
            <div className="col-lg-6 position-relative z-1">
              <ul className="ico_features_group unordered_list_block">
                <li
                  key={index}
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div className="ico_iconbox_icon_left min-140">
                    <div className="iconbox_icon">
                      <img src={feature.icon} alt={feature.title} />
                    </div>
                    <div className="iconbox_info">
                      <h3 className="iconbox_title">{feature.title}</h3>
                      <p className="iconbox_description text-dark mb-0">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          ))}
        </div>
        <div className="text-center py-5">
          <p>
            {" "}
            Real Rewards. No Risk. Just Loyalty. No investments. No gambling. No
            pressure. Just loyalty, rewarded at every level.{" "}
          </p>
          <span className="fs-5 fw-bold">
            Real Rewards. No Risk. Just Loyalty.
          </span>
        </div>
      </div>
    </section>
  );
};

export default TokenomicsSection;
